import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Seo from "../components/Seo";
import AuthShell, { GoogleButton } from "../components/auth/AuthShell";
import { Field, inputCls } from "../components/forms/Fields";
import { useAuth, googleLogin } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your client account" subtitle="Track goals, consultations and reports in one secure place."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-mint-600" data-testid="register-login-link">Sign in</Link></>}>
      <Seo title="Create Account" path="/register" noindex />
      <GoogleButton onClick={googleLogin} />
      <div className="my-6 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />or with email<span className="h-px flex-1 bg-slate-200" /></div>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Full name" id="r-name"><input id="r-name" required minLength={2} className={inputCls} value={form.name} onChange={set("name")} data-testid="register-name-input" /></Field>
        <Field label="Email" id="r-email"><input id="r-email" type="email" required className={inputCls} value={form.email} onChange={set("email")} data-testid="register-email-input" /></Field>
        <Field label="Mobile (optional)" id="r-phone"><input id="r-phone" type="tel" className={inputCls} value={form.phone} onChange={set("phone")} data-testid="register-phone-input" /></Field>
        <Field label="Password (min 6 characters)" id="r-pass"><input id="r-pass" type="password" required minLength={6} className={inputCls} value={form.password} onChange={set("password")} data-testid="register-password-input" /></Field>
        {error && <p className="text-sm text-red-600" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="register-submit-btn" className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-navy text-sm font-semibold text-white hover:bg-navy-700 disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} Create account
        </button>
      </form>
    </AuthShell>
  );
}
